import $ from 'jquery';

window.$ = jQuery;
window.jQuery = jQuery;

import 'owl.carousel/src/js/owl.carousel';
import 'owl.carousel/src/js/owl.navigation';

import './components/vh'
import './components/main'
import './components/services_carousel'
import './components/menu_fixed'
import './components/animate'
import { viewport } from "./components/functions";

$(document).ready(function () {
    function init(el) {
        const speed = el.getAttribute('data-speed') || 1;
        const x = el.getAttribute('data-x') || 'center';
        const mdX = el.getAttribute('data-md-x') || 'center';
        const rect = el.getBoundingClientRect();
        el.style.objectPosition = (viewport().width >= 992 ? mdX : x) + ' ' + (-rect.top) * speed + 'px';
    }

    const elements = document.querySelectorAll(".parallax");
    elements.forEach(function (el) {
        init(el);

        window.addEventListener("scroll", function () {
            init(el)
        });
        window.addEventListener("resize", function () {
            init(el)
        });
    });
});
